import Joyride, { Callback } from 'react-joyride';

import { useApplicationSetup } from '@page/application-setup/application-setup.hook';
import { userActions } from '@store/user/user.slice';

import { RouteEnum } from '@enum/route.enum';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useUserGuide } from '@hook/user/use-user-guide.hook';
import { useSaveGuidesMutation } from '@hook/user/user.hooks';

import { locale, steps } from './main-guide.options';
import { mainGuideStyle } from './main-guide.style';

export const MainGuid = () => {
  const { name } = useApplicationSetup();
  const { completedDashboard } = useUserGuide();
  const { action: saveGuides } = useMutation(useSaveGuidesMutation(), userActions, userActions.setGuides);

  const run = !completedDashboard && name === RouteEnum.Dashboard.name;

  const handleSaveGuides: Callback = ({ status }) => {
    if (status === 'skipped') {
      saveGuides({ completedCreateApplication: true, completedConsumer: true, completedDashboard: true });
    }
    if (name === RouteEnum.Dashboard.name && status === 'finished') {
      saveGuides({ completedDashboard: true });
    }
  };

  if (completedDashboard) return null;

  return (
    <Joyride
      callback={handleSaveGuides}
      locale={locale}
      run={run}
      steps={steps}
      styles={mainGuideStyle}
      continuous
      disableScrolling
    />
  );
};
